import Vue from 'vue'

export const EventBus = new Vue()

export const events = {
  companyAdded: 'companyAdded',
  companyRemoved: 'companyRemoved',
  menuAdded: 'menuAdded',
  menuRemoved: 'menuRemoved',
  changePassword: 'changePassword',
  showLoading: 'showLoading',
  hideLoading: 'hideLoading',
  openConfirm: 'openConfirm',
  resolveConfirm: 'resolveConfirm',
  sessionTimedOut: 'sessionTimedOut',
  openDifferences: 'openDifferences'
}
